import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { storesApi } from "../../api";
import { IInfoAndHome } from "../types";



type InfoState = {
    loading: boolean
    error: null | string
    info: null | IInfoAndHome
}

const initialState: InfoState = {
    error: null,
    loading: false,
    info: null,
}


export const fetchByCompanyInfo = createAsyncThunk(
    'info/fetchByCompanyInfo',
    async (_, { rejectWithValue }) => {
        try {
            const res = await storesApi.getMainAndInfoCompany()
            return res.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Ошибка сервера');
        }
  
    })





const infoSlice = createSlice({
    name: 'info',
    initialState,
    reducers: {},
    extraReducers: ({ addCase }) => {
        addCase(fetchByCompanyInfo.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        addCase(fetchByCompanyInfo.fulfilled, (state, action) => {
            state.info = action.payload;
            state.loading = false;
        });
        addCase(fetchByCompanyInfo.rejected, (state) => {
            state.loading = false;
            state.error = 'Ошибка сервера!';
        });

    },
})



export default infoSlice.reducer





